import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"
import {
  EVENT_CONTRACT_CHAIN_CONTRACT_DESER,
  EventContractChainContract,
} from "./event-contract-chain"

export class EventContractsGridTimeSlot {
  startsTradingAt = ""
  stopsTradingAt = ""
  contracts: EventContractChainContract[] = []
}

export const EVENT_CONTRACTS_GRID_TIME_SLOT_DESER: SchemaDeSer<EventContractsGridTimeSlot> =
  new SchemaDeSerBuilder(EventContractsGridTimeSlot)
    .ofString("startsTradingAt", "starts-trading-at")
    .ofString("stopsTradingAt", "stops-trading-at")
    .ofArray(
      "contracts",
      EVENT_CONTRACT_CHAIN_CONTRACT_DESER,
      EventContractChainContract
    )
    .toDeSer()

export class EventContractsGrid {
  titleShort = ""
  title = ""
  underlyingSymbol = ""
  timeSlots: EventContractsGridTimeSlot[] = []
}

export const EVENT_CONTRACTS_GRID_DESER: SchemaDeSer<EventContractsGrid> =
  new SchemaDeSerBuilder(EventContractsGrid)
    .ofString("titleShort", "title-short")
    .ofString("title")
    .ofString("underlyingSymbol", "underlying-symbol")
    .ofArray(
      "timeSlots",
      EVENT_CONTRACTS_GRID_TIME_SLOT_DESER,
      EventContractsGridTimeSlot
    )
    .toDeSer()
